import { computed } from 'vue'

import type { CurrencyInfo } from '../utils/currencyHelper'
import { currency } from '../utils/currencyHelper'

const DEFAULT_CURRENCY_CODE = 'USD'
const MAX_MINOR_UNITS = 999_999_999_999

export type CurrencyOption = {
  value: string
  label: string
}

const getCurrencyInfo = (currencyCode?: string): CurrencyInfo => {
  return currency[currencyCode || DEFAULT_CURRENCY_CODE] || currency[DEFAULT_CURRENCY_CODE]
}

export function useCurrency() {
  const currencyOptions = computed<CurrencyOption[]>(() => {
    return Object.values(currency).map(({ code }) => ({
      value: code,
      label: code,
    }))
  })

  const getCurrencySymbol = (currencyCode?: string): string => {
    return getCurrencyInfo(currencyCode).symbol
  }

  const formatAmount = (currencyCode?: string): number => {
    const decimals = getCurrencyInfo(currencyCode).decimal_digits

    if (!Number.isInteger(decimals) || decimals < 0) {
      return MAX_MINOR_UNITS / 100
    }

    return MAX_MINOR_UNITS / Math.pow(10, decimals)
  }

  return {
    currencyOptions,
    getCurrencySymbol,
    formatAmount,
  }
}
